export default __webpack_public_path__ + "static/media/graph-3.2d009386.png";